'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t$1 from "../defs/Medal.js";
var i = Object.defineProperty, p = Object.defineProperties;
var s = Object.getOwnPropertyDescriptors;
var a = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
var t = (o, e, r) => e in o ? i(o, e, { enumerable: true, configurable: true, writable: true, value: r }) : o[e] = r, m = (o, e) => {
  for (var r in e || (e = {}))
    c.call(e, r) && t(o, r, e[r]);
  if (a)
    for (var r of a(e))
      d.call(e, r) && t(o, r, e[r]);
  return o;
}, f = (o, e) => p(o, s(e));
const M = forwardRef((o, e) => /* @__PURE__ */ a__default.createElement(b, f(m({ ref: e }, o), { weights: t$1 })));
M.displayName = "Medal";
export {
  M as Medal
};
